import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
// import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import { Button, Dropdown, NavDropdown } from "react-bootstrap";
// import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import * as React from "react";
import { Fragment } from "react";
// import logo from "../images/Logo3.PNG";
import SearchIcon from "@mui/icons-material/Search";
import { Link } from "react-router-dom";
import NotificationBadge from "react-notification-badge/lib/components/NotificationBadge";
import { Effect } from "react-notification-badge";
import "./NavigationBar.css";

const NavigationBar = ({
  notifications,
  notifCount,
  clearNotifCount,
  markAllAsRead,
  handleNotificationClick,
}) => {
  const notificationsReverse = [...notifications].reverse();
  // const truckerUserName = localStorage.getItem("company_name");

  return (
    <Fragment>
      <AppBar
        position="fixed"
        style={{ backgroundColor: "#ffffff", left: 260, width: "calc(100% - 260px)", boxShadow: "0 2px 4px rgba(0,0,0,0.08)"}}
      >
        {/* <Container
          // maxWidth="lg"
          style={{ backgroundColor: "#303230", width: "100%" }}
        > */}
          <Toolbar disableGutters>
            <Typography variant="h6" component="div" sx={{ display: { xs: "flex" }, mr: 2 }}></Typography>

            <Box sx={{ flex: 1, maxWidth: 400, ml: 2, mr: 2 }}>
              <TextField
                variant="outlined"
                size="small"
                placeholder="Search..."
                fullWidth
                sx={{
                  borderRadius: '8px',
                  backgroundColor: '#f8fafc',
                  '& .MuiOutlinedInput-root': {
                    paddingLeft: '8px',
                    '& fieldset': { borderColor: '#e5e7eb', borderRadius: '8px' },
                    '&:hover fieldset': { borderColor: '#cbd5e1' },
                    '&.Mui-focused fieldset': { borderColor: '#6366f1', boxShadow: '0 0 0 3px rgba(99,102,241,0.15)' },
                  },
                  '& .MuiInputBase-input': {
                    padding: '8px 12px',
                    fontSize: '14px',
                    color: '#1e293b',
                  },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon sx={{ color: '#9ca3af' }} />
                    </InputAdornment>
                  ),
                }}
              />
            </Box>
            <NavDropdown
              onClick={clearNotifCount}
              className="mr-2 first-dropdown"
              style={{marginLeft:'auto'}}
              title={
                <>
                  <NotificationBadge
                    style={{ zIndex: "10000" }}
                    count={notifCount.length}
                    effect={Effect.SCALE}
                  />

                  <ion-icon
                    name="notifications"
                    style={{
                      color: "#0f172a",
                      fontSize: "22px",
                    }}
                  ></ion-icon>
                </>
              }
              id="collasible-nav"
            >
              <div className="p-3" >
                <div className="d-flex align-items-center justify-content-between">
                  <p style={{ fontSize: "18px", fontWeight: "bold" }}>
                    Notifications
                  </p>
                  <Button
                    title="Mark all as read"
                    className="mark-all-as-read-btn"
                    onClick={markAllAsRead}
                  >
                    <ion-icon
                      style={{ fontSize: "30px" }}
                      name="checkmark-done-circle"
                    ></ion-icon>
                  </Button>
                </div>

                {notifications.length > 0 ? (
                  <div>
                    {notificationsReverse.map((notification, index) => (
                      <div
                        key={index}
                        style={{
                          backgroundColor: notification.clicked
                            ? "transparent"
                            : "#dee2e6",
                        }}
                        onClick={() => handleNotificationClick(notification)}
                      >
                        <NavDropdown.Item
                          style={{ fontSize: "16px" }}
                          onClick={notification.onClick}
                        >
                          <p
                            className="m-0"
                            style={{
                              fontWeight: "bold",
                              fontSize: "16px",
                              color: notification.clicked ? "#6c757d" : "#000",
                            }}
                          >
                            {notification.title}
                          </p>
                          <p
                            style={{
                              whiteSpace: "pre-wrap",
                              fontSize: "14px",
                              color: notification.clicked ? "#6c757d" : "#000",
                            }}
                            className="m-0"
                          >
                            {notification.message}
                          </p>
                        </NavDropdown.Item>
                        {index !== notifications.length - 1 && (
                          <Dropdown.Divider />
                        )}
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="p-2">
                    <NavDropdown.Item style={{ fontSize: "16px" }}>
                      No new Notifications
                    </NavDropdown.Item>
                  </div>
                )}
              </div>
            </NavDropdown>
            <Box sx={{ flexGrow: 0, gap: "10px", display: 'flex', alignItems: 'center' }}>
              <NavDropdown
                title={
                  <span style={{ color: "#111827", fontWeight: 600, display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                    {localStorage.getItem("company_name")
                      ? localStorage.getItem("company_name")
                      : ""}
                    <span style={{ marginLeft: 6, fontSize: '12px' }}>▼</span>
                  </span>
                }
                align="end"
              >
                <NavDropdown.Item style={{ padding: '4px 8px' }}>
                  <Link to="/edituser" style={{ textDecoration: 'none', display: 'block', width: '100%' }}>
                    <button
                      style={{
                        background: "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
                        color: "#fff",
                        width: "100%",
                        border: "none",
                        borderRadius: "999px",
                        padding: "10px 16px",
                        boxShadow: "0 6px 12px rgba(99,102,241,0.25)",
                        fontWeight: 600,
                        fontSize: '14px',
                        cursor: 'pointer'
                      }}
                    >
                      Edit User
                    </button>
                  </Link>
                </NavDropdown.Item>
                <NavDropdown.Item style={{ padding: '4px 8px' }}>
                  <Link to="/resetpass" style={{ textDecoration: 'none', display: 'block', width: '100%' }}>
                    <button
                      style={{
                        background: "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
                        color: "#fff",
                        width: "100%",
                        border: "none",
                        borderRadius: "999px",
                        padding: "10px 16px",
                        boxShadow: "0 6px 12px rgba(99,102,241,0.25)",
                        fontWeight: 600,
                        fontSize: '14px',
                        cursor: 'pointer'
                      }}
                    >
                      Reset Password
                    </button>
                  </Link>
                </NavDropdown.Item>
                <NavDropdown.Item style={{ padding: '4px 8px' }}>
                  <button
                    onClick={() => {
                      if (window.confirm("Are you sure you want to logout?")) {
                        localStorage.clear();
                        window.location = "/";
                      }
                    }}
                    style={{
                      background: "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
                      color: "#fff",
                      width: "100%",
                      border: "none",
                      borderRadius: "999px",
                      padding: "10px 16px",
                      boxShadow: "0 6px 12px rgba(99,102,241,0.25)",
                      fontWeight: 600,
                      fontSize: '14px',
                      cursor: 'pointer'
                    }}
                  >
                    Logout
                  </button>
                </NavDropdown.Item>
              </NavDropdown>
            </Box>
          </Toolbar>
      </AppBar>
    </Fragment>
  );
};
export default NavigationBar;
